module.exports = __webpack_public_path__ + "static/media/Brand-Icons.55653f74.woff";